import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { StepPage } from '~/client-flow/components/StepPage';
import { useLocaleKeys } from '~/i18n';
import { COBStep, getStepName, stepsTextsPath } from '../ClientOnboarding.utils';
import { useCobConfig } from '../CobConfigContext';
import { ReviewServices } from '../ReviewServices/ReviewServices';
export const { ReviewServicesStepTestIds } = getTestIds();
export default function ReviewServicesStep(param) {
    let { selectedBundleID, selectedOptionalServices, onDone, onBack, setSelectedOptionalServices } = param;
    const { relationship } = useCobConfig();
    const { t: stepsTexts } = useLocaleKeys(stepsTextsPath);
    const { t: footerTexts } = useLocaleKeys('clientFlow.footer');
    return /*#__PURE__*/ _jsx(StepPage, {
        header: getStepName(COBStep.reviewServices, relationship, stepsTexts),
        primaryBtn: /*#__PURE__*/ _jsx(Button, {
            onClick: ()=>{
                onDone();
            },
            children: footerTexts.next()
        }),
        onBackBtnClick: onBack,
        testId: ReviewServicesStepTestIds.Root(),
        children: /*#__PURE__*/ _jsx(ReviewServices, {
            relationship: relationship,
            selectedBundleId: selectedBundleID,
            selectedOptionalServices: selectedOptionalServices,
            setSelectedOptionalServices: setSelectedOptionalServices
        })
    });
}
